import { mapMutations, mapState, mapGetters } from 'vuex';
import * as S from './styles';

import PanelOptionMixin from '../mixin';

import Switch from '@components/Common/Switch';
import ShowTotalRowIcon from '@svgIcons/show_total_row.svg';
import { isValueExist } from '@/utils/utils';

export default {
    name: 'WidgetSettingPanelTableOptions',
    mixins: [PanelOptionMixin],
    methods: {
        ...mapMutations('dashboardHeader', ['setGridShowTotalRow']),
    },
    computed: {
        ...mapState('dashboardHeader', ['gridShowTotalRow']),
        ...mapGetters('newDashboard', [
            'editingWidgetId',
            'currentWidgetsById',
        ]),
    },
    watch: {
        editingWidgetId: {
            handler(v) {
                const { gridShowTotalRow = true } =
                    this.currentWidgetsById[v] || {};
                this.setGridShowTotalRow(gridShowTotalRow);
            },
            immediate: true,
        },
    },
    render() {
        const { gridShowTotalRow = true, setGridShowTotalRow, disabled } = this;

        return (
            <S.ComponentWrapper isDisabled={disabled}>
                <div class="top-wrapper">
                    <div class="title">
                        <ShowTotalRowIcon class="total_row-icon" />
                        <h1>{this.$t('NEW_DASHBOARD.showTotalRow')}</h1>
                    </div>
                    <Switch
                        value={gridShowTotalRow}
                        type="big"
                        onClick={() => setGridShowTotalRow(!gridShowTotalRow)}
                        disabled={disabled}
                    />
                </div>
            </S.ComponentWrapper>
        );
    },
};
